import { v4 as uuidv4 } from 'uuid'

/**
 * Generacion de IDs para la capa offline-v2.
 *
 * NO usar `crypto.randomUUID()` directo: requiere secure context (https) y NO existe
 * en WebViews viejos (Capacitor WKWebView / Android System WebView legacy). El paquete
 * `uuid` (ya instalado ^14.0.0) funciona en todos los targets de despliegue.
 *
 * Fuente unica de IDs offline: los consumidores externos (mixins/componentes) importan de aqui.
 */

/** UUID v4 para client_uuid de entidades y mutation_uuid del outbox. */
export const newId = () => uuidv4()

/**
 * True si el id parece un server_id de Aurora (entero positivo), sea number o string numérica.
 * Los client_uuid (uuid v4) NUNCA matchean. Permite distinguir una entidad ya persistida en el
 * server (id numérico) de una creada offline (client_uuid) al construir su clave local.
 * @param {string|number|null|undefined} id
 * @returns {boolean}
 */
export const isServerId = id => {
  if (id == null) return false
  if (typeof id === 'number') return Number.isInteger(id) && id > 0
  if (typeof id === 'string') return /^[0-9]+$/.test(id) && Number(id) > 0
  return false
}

/**
 * client_uuid con el que la capa offline identifica una tarea: el id de una tarea del server se traduce a
 * `srv:task:<id>` y un client_uuid (tarea creada offline) se deja tal cual.
 * @param {string|number} id
 * @returns {string}
 */
export function taskClientUuid (id) {
  return isServerId(id) ? `srv:task:${Number(id)}` : String(id)
}
